import translate from '@e4/intl/translate.macro';
import { Padlock } from '../assets';
import { logoff as logOffAndRedirect } from '@e4/ebanking-web-logoff';

const logOff = {
  text: translate('webMenu.logOff'),
  onClick: logOffAndRedirect,
  Icon: Padlock,
};

export default logOff;
